module.exports = __webpack_public_path__ + "static/img/c3.834fe47.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/c3.png
// module id = VRfx
// module chunks = 0